import ToolTip from "@mui/material/Tooltip";
import React, { memo } from "react";
import { StyleSheet, Text } from "react-native";
import { FONT_FAMILY } from "../themes";

const JobCardSparePartToolTip = ({ partDetails, isSparePartsServiceAvailable, brand }) => {
  const product = partDetails?.[0]?.sku_dict?.product;

  if (!isSparePartsServiceAvailable)
    return (
      <Text style={[styles.rowText, { marginBottom: 20 }]}>
        <span style={{ fontFamily: FONT_FAMILY.three, fontSize: 13 }}>Brand</span>
        {"\n"}
        {brand || "---"}
      </Text>
    );

  return (
    <ToolTip
      slotProps={{
        tooltip: {
          sx: { padding: "0rem", borderRadius: 5, background: "red" },
        },
      }}
      placement="bottom"
      title={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            backgroundColor: "white",
            padding: 10,
            boxShadow: "5px 5px 25px rgba(0, 0, 0, 0.08)",
            borderRadius: 5,
          }}
        >
          <Text style={styles.rowText}>
            <span style={{ fontFamily: FONT_FAMILY.three, fontSize: 13 }}>Part Number</span>
            {"\n"}
            {product?.part_number || "---"}
          </Text>
          <Text style={styles.rowText}>
            <span style={{ fontFamily: FONT_FAMILY.three, fontSize: 13 }}>Brand</span>
            {"\n"}
            {product?.brand || "---"}
          </Text>
          <Text style={styles.rowText}>
            <span style={{ fontFamily: FONT_FAMILY.three, fontSize: 13 }}>Brand Type</span>
            {"\n"}
            {product?.brand_type || "---"}
          </Text>
        </div>
      }
    >
      <Text style={[styles.rowText, { marginBottom: 20 }]}>
        <span style={{ fontFamily: FONT_FAMILY.three, fontSize: 13 }}>Part Name</span>
        {"\n"}
        {product?.product_name || "---"}
      </Text>
    </ToolTip>
  );
};

export default memo(JobCardSparePartToolTip);

const styles = StyleSheet.create({
  rowText: {
    fontFamily: FONT_FAMILY.two,
    fontSize: 15,
    letterSpacing: 0.1,
    marginBottom: 10,
  },
});
